import React from "react";

function StepLayout({ title, description, children }) {
  return (
    <section>
      <div className="px-7 py-5 border-b bg-gray-50">
        <h2 className="text-gray-800 text-xl md:text-2xl hidden md:block">
          {title}
        </h2>
        <p className="text-gray-500 text-sm mt-1">{description}</p>
      </div>

      <div className="px-7 py-5">{children}</div>
    </section>
  );
}

export default StepLayout;
